module.exports = __webpack_public_path__ + "static/media/walk-point.e7cd4c06.png";